<template>
  <div @click="toggleAudio" class="autoplay">
    <div class="autoplay-label">{{ $t('message.Autoplay_Sound') }} </div>
    <img class="chapter" src="@/assets/images/chapter.svg"/>
    <div class="autoplay-state" :class="{ off: audioDeactivated }">{{ audioDeactivated ? $t('message.off') : $t('message.on') }}</div>
  </div>
</template>

<script>
export default {
  computed: {
    audioDeactivated () {
      return this.$store.state.audioDeactivated
    }
  },
  methods: {
    toggleAudio () {
      this.$store.commit('setAudioDeactivated', !this.audioDeactivated)
    }
  }
}
</script>

<style lang="scss">
  .autoplay {
    pointer-events: auto;
    // position: absolute;
    // right: 160px;
    // bottom: 64px;
    display: flex;
    font-family: Georgia;
    font-size: 12px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.33;
    letter-spacing: normal;
    text-align: center;
    color: #18333c;
    cursor: pointer;
    .chapter {
      height: 16px;
      width: 16px;
    }
    .off {
      color: #7d939a;
    }
  }
</style>
